"use client";

import { getStorage, ref, uploadBytes } from "firebase/storage";
import { app } from "@/firebase/config";

// Downscale to fit within maxWidth x maxHeight, keep aspect; convert to WEBP.
async function fileToWebpBlob(file, { maxWidth = 800, maxHeight = 500 } = {}) {
  const img = document.createElement("img");
  const url = URL.createObjectURL(file);
  await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = url; });

  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;
  const ratio = Math.min(maxWidth / w, maxHeight / h, 1);
  const targetW = Math.round(w * ratio);
  const targetH = Math.round(h * ratio);

  const canvas = document.createElement("canvas");
  canvas.width = targetW; canvas.height = targetH;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, targetW, targetH);

  const blob = await new Promise((res) => canvas.toBlob(res, "image/webp", 0.9));
  URL.revokeObjectURL(url);
  return blob;
}

export async function uploadProcessedImage({
  file,
  hubSlug,        // <- slug only
  threadId,
  objectKey,      // uuid
  maxWidth = 800,
  maxHeight = 500,
}) {
  const blob = await fileToWebpBlob(file, { maxWidth, maxHeight });
  const storage = getStorage(app);
  const path = `hubs/${hubSlug}/threads/${threadId}/images/${objectKey}.webp`;
  const r = ref(storage, path);
  await uploadBytes(r, blob, {
    contentType: "image/webp",
    cacheControl: "public,max-age=31536000,immutable",
  });
  return { path };
}
